<template>
    <div class="planets-info" v-if="horoscope.criteria">
        <div class="planets-table-area">
            <table class="planets-table" width="100%" border="0">
                <thead>
                    <tr>
                        <th>Jamakkol Inner Planets</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="planet in horoscope.planets.planets" :key="planet.name">
                        <template v-if="planet.jamakkolInnerPlanet">
                        <td align="left">
                            <font size="4"><b><u>{{planet.name}} {{planet.retrograde ? "(R)" : ""}}</u></b></font><br/>
                            <b>{{planet.zodiacSignName}}</b> / <i>{{planet.sanskritZodiacName}}</i><br/>
                            {{planet.relativeDegreeDMS}}<br/>
                            <b>{{planet.englishStarName}}-{{planet.starPada}}</b> / <i>{{planet.tamilStarName}}-{{planet.starPada}}</i>,<br/>
                            Star Lords: <b>{{planet.angularVimsottariPeriod.dasa}}</b>,&nbsp;{{planet.angularVimsottariPeriod.bhukti}},&nbsp;
                            {{planet.angularVimsottariPeriod.antaram}},&nbsp;{{planet.angularVimsottariPeriod.sootchumam}}<br/>
                            <template v-if="planet.sthanaBala">
                                Sthana Bala: <b>{{planet.sthanaBala}}</b><br/>
                            </template>
                            <template v-if="planet.attributeFlags">
                                <template v-for="(attributesDisplay, index) in planet.attributesDisplayList" v-bind:key="index" v-bind:value="attributesDisplay">
                                    {{attributesDisplay}} <br/>
                                </template>
                            </template>
                        </td>
                    </template>
                    </tr>
                </tbody>
            </table>
            <table class="planets-table" width="100%" border="0">
                <thead>
                    <tr>
                        <th>Jamakkol Outer Planets</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="planet in horoscope.planets.planets" :key="planet.name">
                        <template v-if="planet.jamakkolOuterPlanet">
                        <td align="left">
                            <font size="4"><b><u>{{planet.name}} {{planet.retrograde ? "(R)" : ""}}</u></b></font><br/>
                            <b>{{planet.zodiacSignName}}</b> / <i>{{planet.sanskritZodiacName}}</i><br/>
                            {{planet.relativeDegreeDMS}}<br/>
                            <b>{{planet.englishStarName}}-{{planet.starPada}}</b> / <i>{{planet.tamilStarName}}-{{planet.starPada}}</i>,<br/>
                            Star Lords: <b>{{planet.angularVimsottariPeriod.dasa}}</b>,&nbsp;{{planet.angularVimsottariPeriod.bhukti}},&nbsp;
                            {{planet.angularVimsottariPeriod.antaram}},&nbsp;{{planet.angularVimsottariPeriod.sootchumam}}<br/>
                            <template v-if="planet.sthanaBala">
                                Sthana Bala: <b>{{planet.sthanaBala}}</b><br/>
                            </template>
                            <template v-if="planet.attributeFlags">
                                <template v-for="(attributesDisplay, index) in planet.attributesDisplayList" v-bind:key="index" v-bind:value="attributesDisplay">
                                    {{attributesDisplay}} <br/>
                                </template>
                            </template>
                        </td>
                    </template>
                    </tr>
                </tbody>
            </table>
            <table class="planets-table" width="100%" border="0">
                <thead>
                    <tr>
                        <th>Planetary Positions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="planet in horoscope.planets.planets" :key="planet.name">
                        <template v-if="!planet.jamakkolInnerPlanet && !planet.jamakkolOuterPlanet">

                            <td style="text-align: left;">
                                <b>
                                <template v-if="planet.planetAttributes.planetaryPositionReportUrl">
                                    <a :href="planet.planetAttributes.planetaryPositionReportUrl" target="_blank" style="text-decoration:none;color: #087F8C;" 
                                    :title="planet.planetAttributes.planetaryPositionReportText"><u>{{planet.name}}</u></a>
                                </template>
                                <template v-else>
                                    <u>{{planet.name}}</u>
                                </template>
                                {{planet.retrograde ? "(R)" : ""}}</b><br/>
                                <b>{{planet.zodiacSignName}}</b> / <i>{{planet.sanskritZodiacName}}</i><br/>
                                {{planet.relativeDegreeDMS}}<br/>
                                <b>{{planet.englishStarName}}-{{planet.starPada}}</b> / <i>{{planet.tamilStarName}}-{{planet.starPada}}</i>,<br/>
                                Star Lords: <b>{{planet.angularVimsottariPeriod.dasa}}</b>,&nbsp;{{planet.angularVimsottariPeriod.bhukti}},&nbsp;
                                {{planet.angularVimsottariPeriod.antaram}},&nbsp;{{planet.angularVimsottariPeriod.sootchumam}}<br/>
                                <template v-if="planet.sthanaBala">
                                    Sthana Bala: <b>{{planet.sthanaBala}}</b><br/>
                                </template>
                                <template v-if="planet.attributeFlags">
                                    <template v-for="(attributesDisplay, index) in planet.attributesDisplayList" v-bind:key="index" v-bind:value="attributesDisplay">
                                        {{attributesDisplay}} <br/>
                                    </template>
                                </template>
                            </td>
                        </template>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

export default {
	props: {
		horoscope : {
			type: Object
		},
        planetsTitle : {
            type: String
        }
	},
	data() {
		return {
		}
	},
	mounted() {

	},
	methods: {
	}
}
</script>

<style scoped>

.planets-info {
	border: 0px solid;
	display:flex;
	flex-direction: column;
	align-items: center;
	width:100%;
}

.planets-table-area {
	width: 100%;
    padding-left: 20px;
}

.planets-table {
    border-collapse: collapse;
    margin: 5px 0;
    font-size: 0.9em;
    font-family: sans-serif;
    border-radius: 5px;
 }

.planets-table thead tr {
    background-color: #ACD8AA;
    color: #344E41;
    text-align: left;
    font-weight: bold;
}

.planets-table th {
    padding: 12px 15px;
	font-size: 20px;
}

.planets-table td {
    padding: 12px 15px;
    color: #344E41;
}

.planets-table tbody tr {
    border-bottom: 1px solid #dddddd;
}

</style>
